import React from "react";
import { AvatarProps } from "../types";

const Avatar: React.FC<AvatarProps> = ({ src, alt, name, size = "md" }) => {
  const getSizeClasses = () => {
    switch (size) {
      case "sm":
        return "h-6 w-6 text-xs";
      case "md":
        return "h-8 w-8 text-sm";
      case "lg":
        return "h-10 w-10 text-base";
      default:
        return "h-8 w-8 text-sm";
    }
  };

  const getInitials = () => {
    if (name) {
      const parts = name.trim().split(" ");
      if (parts.length >= 2) {
        return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
      }
      return name.charAt(0).toUpperCase();
    }
    return "?";
  };

  if (src) {
    return (
      <img
        src={src}
        alt={alt || name || "Avatar"}
        className={`${getSizeClasses()} rounded-full object-cover`}
      />
    );
  }

  return (
    <div
      className={`${getSizeClasses()} rounded-full bg-gray-300 flex items-center justify-center text-gray-600 font-medium`}
    >
      {getInitials()}
    </div>
  );
};

export default Avatar;
